import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { TextButton, Box, Popover } from '@wix/design-system';
import { InfoCircle } from '@wix/wix-ui-icons-common';
import s from './PopoverHelp.scss';
import HelpCardContent from './HelpCardContent';
import { EDITOR_TYPE, VIEW_MODE } from '@src/utils/constants';
import useBiLogger from '@src/components/Hooks/useBiLogger';
import { useAppContext } from '@src/components/Contexts/AppContext';

type PopoverHelpProps = {
  editorType: keyof typeof EDITOR_TYPE;
  savedComments: any[];
};

const PopoverHelp = ({ editorType, savedComments }: PopoverHelpProps) => {
  const { t } = useTranslation();
  const { logGenericClick } = useBiLogger();
  const {
    state: { loading, commentsFetchPending, viewMode },
  } = useAppContext();
  const [shown, setShown] = useState(false);
  const isSiteEditorTypeStudio = () => editorType === EDITOR_TYPE.STUDIO;
  useEffect(() => {
    if (
      _.isEmpty(savedComments) &&
      !loading &&
      !commentsFetchPending &&
      viewMode === VIEW_MODE.DESKTOP
    ) {
      setShown(true);
    }
  }, [loading, savedComments]);

  const handleTogglePopoverHelp = (isShow: boolean) => {
    logGenericClick({
      click_type: isShow ? 'help' : 'close_light_box',
    });
    setShown(isShow);
  };

  return (
    <Popover
      showArrow
      animate
      placement="bottom"
      shown={shown}
      onClickOutside={() => handleTogglePopoverHelp(false)}
      appendTo="window"
    >
      <Popover.Element>
        <div onClick={() => handleTogglePopoverHelp(!shown)}>
          <Box
            height={isSiteEditorTypeStudio() ? '44px' : '52px'}
            className={isSiteEditorTypeStudio() ? s.helpBtn : ''}
          >
            <Box
              height="100%"
              marginRight="24px"
              verticalAlign="middle"
              marginLeft="24px"
            >
              <Box marginRight="tiny">
                <TextButton
                  size={isSiteEditorTypeStudio() ? 'small' : 'medium'}
                  weight="normal"
                  style={{
                    color: isSiteEditorTypeStudio() ? '#FFFFFF' : '#3899ec',
                  }}
                  prefixIcon={
                    <InfoCircle
                      color={isSiteEditorTypeStudio() ? '#FFFFFF' : '#3899ec'}
                    />
                  }
                  dataHook="client-add-comments-help"
                  skin="dark"
                >
                  {t('get_feedback_header_user_help_button')}
                </TextButton>
              </Box>
            </Box>
          </Box>
        </div>
      </Popover.Element>
      <Popover.Content>
        <HelpCardContent setShow={handleTogglePopoverHelp} show={shown} />
      </Popover.Content>
    </Popover>
  );
};

export default PopoverHelp;
